import { Container, Typography, IconButton, Grid,  Box } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import { ILogo } from '../../styles/components/ILogo';
export default function Header(props: any) {
  return (
    <Container maxWidth="sm" style={{ marginTop: '10px' }}>
      <IconButton
        href="https://github.com/release-pilot/release-pilot-public/tree/master/simulate-ui"
        target="_blank"
        rel="noopener"
        color="primary"
        style={{ position: 'absolute', top: 0, right: 0, margin: '10px' }}
      >
        <GitHubIcon fontSize="large" />
      </IconButton>
      <Grid sx={{ paddingTop: 2, alignContent: 'center' }}>
        <center>
          <ILogo src="/assets/Single_mainlogo_tm.svg" />
        </center>
      </Grid>
      <Box textAlign="center" py={5}>
        <Typography variant="h4" component="h1" gutterBottom>
          Simulate UI
        </Typography>
        <Typography variant="h6" component="h1" gutterBottom>
          Redirection Journey Simulator
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Easily simulate and test redirect flows during development to ensure a smooth and predictable user journey.
        </Typography>
      </Box>

      {props.children}

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
        <Typography variant="body1" style={{ marginLeft: '5px', fontSize: '24px' }}>
          Crafted with ❤️ in India
        </Typography>
      </div>
    </Container>
  );
}
